import {
	ApiResponseSuccess,
	getDeviceTabletList,
	verifyTabletRegisterCode,
	verifyTabletRemoteCode,
} from '@/services';
import {
	IDeviceTabletVerifyRegisterCodeResponse,
	IDeviceTabletVerifyRemoteCodeResponse,
	TGetDeviceTabletListResponse,
} from '@/services/api/api.type';
import { persistDeviceToken } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import { formatDeviceTabletList } from './device-tablet.helper';
import { DeviceTabletActions } from './device-tablet.redux';
import {
	IPayloadGetDeviceTabletListRequest,
	IPayloadVerifyTabletRegisterCodeRequest,
	IPayloadVerifyTabletRemoteCodeRequest,
} from './device-tablet.type';

export function* getDeviceTabletListSaga(
	action: PayloadAction<IPayloadGetDeviceTabletListRequest>
) {
	const { callback, ...params } = action.payload;

	try {
		const res: ApiResponseSuccess<TGetDeviceTabletListResponse> =
			yield getDeviceTabletList({ ...params });
		const total = res?.data?.total || 0;
		const list = formatDeviceTabletList(res?.data?.content || [], {
			total,
			page: params.page || 1,
			pageSize: params.pageSize || 10,
		});

		yield put(
			DeviceTabletActions.getDeviceTabletListSuccess({
				list,
				totalCount: total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceTabletActions.getDeviceTabletListFailure());
	}
}

export function* verifyTabletRegisterCodeSaga(
	action: PayloadAction<IPayloadVerifyTabletRegisterCodeRequest>
) {
	const { callback, ...payload } = action.payload;

	try {
		const res: ApiResponseSuccess<IDeviceTabletVerifyRegisterCodeResponse> =
			yield verifyTabletRegisterCode(payload);
		persistDeviceToken(res.data.deviceToken);

		yield put(DeviceTabletActions.verifyTabletRegisterCodeSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceTabletActions.verifyTabletRegisterCodeFailure());
	}
}

export function* verifyTabletRemoteCodeSaga(
	action: PayloadAction<IPayloadVerifyTabletRemoteCodeRequest>
) {
	const { callback, ...payload } = action.payload;

	try {
		const res: ApiResponseSuccess<IDeviceTabletVerifyRemoteCodeResponse> =
			yield verifyTabletRemoteCode(payload);
		persistDeviceToken(res.data.deviceToken);

		yield put(DeviceTabletActions.verifyTabletRemoteCodeSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceTabletActions.verifyTabletRemoteCodeFailure());
	}
}
